<template>
  <div class="logistics-info">
    <div class="return-goods logistics-info-mod">
      <div class="mod-title">{{orderInfo.apply_type === 0 || orderInfo.apply_type === 1 ? '退款商品' : '售后商品'}}</div>
      <div
        v-for="(item, index) in orderInfo.cartInfo"
        :key="index"
        class="return-goods-container"
      >
        <div class="good-img-text">
          <div class="good-img">
            <img :src="item.productInfo.image" />
          </div>
          <div class="good-text">
            <div class="good-title-value">
              <div class="good-title">{{ item.productInfo.store_name }}</div>
              <div class="good-value">{{ item.productInfo.attrInfo.suk }}</div>
            </div>
            <div class="amount">￥{{ item.productInfo.attrInfo
                ? item.productInfo.attrInfo.price
                : item.productInfo.price }}</div>
          </div>
        </div>
        <div class="good-count">
          <div class="count">×{{ item.cart_num }}</div>
        </div>
      </div>
    </div>
    <div class="return-info logistics-info-mod">
      <div class="mod-title">{{orderInfo.apply_type === 0 || orderInfo.apply_type === 1 ? '退款物流信息' : '售后物流信息'}}</div>
      <van-cell-group>
        <van-field
          v-model="LogisticsNumber"
          label="物流单号"
          required
          placeholder="请填写物流单号"
          input-align="right"
          :border="false"
          @input="numberChange"
        />
        <van-field
          @click="popCompanySelect"
          is-link="true"
          v-model="Logistics"
          label="物流公司"
          required
          readonly
          placeholder="请选择"
          input-align="right"
          :border="false"
        />
        <van-popup
          v-model="showCompany"
          position="bottom"
          :style="{ height: '40%' }"
        >
          <div class="company-container">
            <div class="search-box">
              <van-search
                @input="searchCompany"
                v-model="LogisticsValue"
                placeholder="请输入搜索关键词"
              />
            </div>
            <ul class="company-list">
              <li
                v-for="(item, index) in companyListView"
                :key="index"
                @click="selectCompany(item)"
                class="company-item"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </van-popup>
        <van-field
          v-model="phone"
          label="联系电话"
          required
          placeholder="请填写联系电话"
          input-align="right"
          :border="false"
        />
      </van-cell-group>
    </div>
    <!-- <div class="return-desc logistics-info-mod">
      <div class="mod-title">退款说明</div>
      <div>
        <van-field
          v-model="message"
          rows="2"
          autosize
          label=""
          label-width="0"
          type="textarea"
          maxlength="200"
          placeholder="有助于我们更好的处理售后问题"
          show-word-limit
        />
      </div>
    </div> -->
    <div class="logistics-info-btn" @click="submitInfo">提交</div>
  </div>
</template>
<script>
import { getLogistics } from "@api/public";
import { orderDetail, postOrderRefundExpressinfo } from "@api/order";
import { getUserInfo } from "@api/user";
import Field from "vant/lib/field";
import "vant/lib/field/style";
import Popup from "vant/lib/popup";
import "vant/lib/popup/style";
import Search from "vant/lib/search";
import "vant/lib/search/style";
export default {
  name: "FillLogisticsInfo",
  components: {
    [Field.name]: Field,
    [Popup.name]: Popup,
    [Search.name]: Search,
  },
  data() {
    return {
      LogisticsNumber: "", //物流单号
      phone: "", //联系电话
      message: "", //备注信息
      showCompany: false, //物流公司弹出
      companyList: [], //物流公司列表
      companyListView: [],
      Logistics: "", //物流公司
      LogisticsValue: "",

      order_id: "", //订单id
      orderInfo: {}, //订单信息
      userInfo: {},
    };
  },
  mounted() {
    this.order_id = this.$route.params.order_id;
    this.getOrderDetail();
    this.getLogistics();
    this.getUserInfo();
  },
  methods: {
    /**
     * 获取订单信息
     */
    getOrderDetail() {
      orderDetail(this.order_id).then((res) => {
        if(res.status === 200){
          this.orderInfo = res.data;
        }else{
          this.$dialog.message(res.msg)
        }
        
      }).catch(err => {
        this.$dialog.error(err.msg)
      });
    },
    /**
     * 获取物流公司
     */
    getLogistics() {
      getLogistics().then((res) => {
        if(res.status === 200){
          this.companyList = res.data;
          this.companyListView = res.data;
        }else{
          this.$dialog.message(res.msg)
        }
        
      }).catch(err => {
        this.$dialog.error(err.msg);
      });
    },
    /**
     * 用户信息
     */
    getUserInfo() {
      getUserInfo().then((res) => {
        if(res.status === 200){
          this.userInfo = res.data;
        }else{
          this.$dialog.message(res.msg)
        }
        
      }).catch(err => {
        this.$dialog.error(err.msg)
      });
    },
    /**
     * 弹出物流公司选择
     */
    popCompanySelect() {
      this.showCompany = !this.showCompany;
    },
    /**
     * 选择物流公司
     */
    selectCompany(item) {
      this.Logistics = item.name;
      this.showCompany = false;
    },
    /**
     * 搜索物流公司
     */
    searchCompany() {
      let that = this;
      that.companyListView = [];
      that.companyListView = that.companyList.filter((item) => {
        if (item.name.indexOf(that.LogisticsValue) !== -1) return item;
      });
    },
    /**
     * 提交
     */
    submitInfo() {
      let that = this;
      if (that.LogisticsNumber.length === 0)
        return that.$dialog.message("请填写物流单号");
      if (that.Logistics.length === 0 || that.Logistics == "")
        return that.$dialog.message("请选择物流公司");
      if (that.phone.length === 0 || that.phone == "")
        return that.$dialog.message("请填写联系电话");
      if (!/^1[34578]\d{9}$/.test(that.phone))
        return that.$dialog.message("请填写正确的联系电话");
      let data = {
        order_id: that.order_id,
        uid: that.userInfo.uid,
        delivery_name: that.Logistics,
        delivery_id: that.LogisticsNumber,
        phone: that.phone,
      };
      postOrderRefundExpressinfo(data).then(res => {
        if(res.status === 200){
          this.$dialog.success("提交成功");
          setTimeout(()=>{
            this.$router.go(-1);
          },1000)
        }else{
          this.$dialog.message(res.msg)
        }
      }).catch(err => {
        this.$dialog.error(err.msg)
      });
    },
    /**
     * 快递单号正则
     */
    numberChange(value){
      return this.LogisticsNumber = this.LogisticsNumber.replace(/[^a-zA-Z0-9]*/g,"")
    }
  },
};
</script>
<style scoped>
.logistics-info {
  padding: 0 0.2rem;
}
.return-goods {
  background: #fff;
  padding: 0.2rem;
  margin-top: 0.3rem;
  border-radius: 10px;
  box-shadow: 0px 2px 9px #f1f1f1;
}
.logistics-info-mod {
  background: #fff;
  padding: 0.2rem;
  margin-top: 0.3rem;
  border-radius: 10px;
  box-shadow: 0px 2px 9px #f1f1f1;
}
.mod-title {
  font-size: 0.3rem;
  font-weight: 800;
  margin-bottom: 0.16rem;
}
.return-goods-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 1.7rem;
}

.return-goods-container .good-img-text {
  display: flex;
}
.return-goods-container .good-img {
  width: 25%;
  margin-right: 0.2rem;
}
.good-img-text .good-text {
  display: flex;
  flex-wrap: wrap;
}
.good-text .good-title-value {
  width: 100%;
}
.good-title-value .good-title {
  font-size: 0.28rem;
  font-weight: 500;
  color: #000;
}
.good-title-value .good-value {
  color: #a0a0a0;
  font-size: 0.26rem;
  margin-top: 0.06rem;
}
.return-goods-container .amount-count {
  /* width: 20%; */
}
.good-img img {
  width: 100%;
}
.good-count .count {
  font-size: 0.28rem;
  color: #a0a0a0;
}
.logistics-info-btn {
  text-align: center;
  margin-top: 0.3rem;
  font-size: 0.3rem;
  height: 0.8rem;
  line-height: 0.8rem;
  border-radius: 25px;
  color: #fff;
  background: linear-gradient(90deg, #f5d9a8, #dab884);
  background: -webkit-linear-gradient(90deg, #f5d9a8, #dab884);
  background: -moz-linear-gradient(90deg, #f5d9a8, #dab884);
  background: -ms-linear-gradient(90deg, #f5d9a8, #dab884);
}
.search-box {
  position: sticky;
  top: 0;
  width: 100%;
}
.company-list {
  padding: 0 0.2rem 0.5rem;
}
.company-list .company-item {
  font-size: 0.3rem;
  padding: 0.18rem;
}
.company-list .company-item:active {
  background: #f2f3f5;
}
</style>